import React from 'react'
import styles from './confidenceTick.module.scss'
import classNames from 'classnames'
import { ReactComponent as IconTick } from 'images/icons/icn_confidence_tick.svg'
import { HIGH_CONFIDENCE_THRESHOLD } from 'constants/global'

interface Props {
  score: number | undefined
  className?: string
}

const ConfidenceTick = ({ score, className = '' }: Props) => {
  if (!score) return null

  return (
    <span
      className={classNames(styles.confidenceTick, className, {
        [styles.low]: score <= HIGH_CONFIDENCE_THRESHOLD,
        [styles.high]: score > HIGH_CONFIDENCE_THRESHOLD,
      })}
      aria-label={`confidence level ${score}%`}
    >
      <IconTick aria-hidden />
    </span>
  )
}

export default ConfidenceTick
